export const RECOMMENDED_TYPES = {
    RECOMMENDED: 'recommended',
    CUSTOMIZED: 'customized'
};
